import { SITE_NAME } from '../config/siteBranding';
import { getShareOrigin } from './canonicalOrigin';

/** Resolve photo URL for display (Cloudinary, frontend public assets, or local API path) */
export function mediaUrl(url) {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('data:')) {
    return url;
  }
  // Same-origin frontend files (public/, CRA static media). API uploads stay under /api/.
  if (url.startsWith('/') && !url.startsWith('/api/')) {
    return url;
  }
  const apiBase = (process.env.REACT_APP_API_URL || 'http://localhost:8080/api').replace(/\/api\/?$/, '');
  return `${apiBase}${url.startsWith('/') ? url : `/${url}`}`;
}

export function formatBlogDate(dateString) {
  if (!dateString) return '';
  return new Date(dateString).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}

export function getBlogPostUrl(slug) {
  if (!slug) return '';
  const path = `/blog/${slug}`;
  if (typeof window === 'undefined') {
    return path;
  }
  return `${getShareOrigin()}${path}`;
}

export function buildBlogShareMessage({ title, excerpt, url }) {
  let message = `📰 *${SITE_NAME}*\n`;
  message += `*${title || 'Blog post'}*\n\n`;
  if (excerpt) {
    message += `${excerpt}\n\n`;
  }
  message += `👉 Read more:\n${url}`;
  return message;
}

export function getWhatsAppShareUrl(message) {
  return `https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`;
}

export function getFacebookShareUrl(url) {
  return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
}

export function shareBlogViaWhatsApp(post) {
  const url = getBlogPostUrl(post.slug);
  const message = buildBlogShareMessage({
    title: post.title,
    excerpt: post.excerpt,
    url,
  });
  window.open(getWhatsAppShareUrl(message), '_blank', 'noopener,noreferrer');
}

export function shareBlogViaFacebook(post) {
  const url = getBlogPostUrl(post.slug);
  window.open(getFacebookShareUrl(url), '_blank', 'noopener,noreferrer,width=600,height=400');
}

export async function shareBlogViaInstagram(post) {
  const url = getBlogPostUrl(post.slug);
  const text = buildBlogShareMessage({
    title: post.title,
    excerpt: post.excerpt,
    url,
  });
  try {
    await navigator.clipboard.writeText(text);
    return { copied: true };
  } catch {
    return { copied: false, text };
  }
}

export async function copyBlogLink(post) {
  const url = getBlogPostUrl(post.slug);
  try {
    await navigator.clipboard.writeText(url);
    return true;
  } catch {
    return false;
  }
}

export const REFERENCE_LINK_PRESETS = [
  { label: 'Facebook', placeholder: 'https://facebook.com/...' },
  { label: 'Instagram', placeholder: 'https://instagram.com/...' },
  { label: 'Website', placeholder: 'https://...' },
  { label: 'YouTube', placeholder: 'https://youtube.com/...' },
  { label: 'Other', placeholder: 'https://...' },
];

export function normalizeReferenceLinks(links) {
  if (!Array.isArray(links)) return [];
  return links
    .map((link) => ({
      label: (link?.label || '').trim(),
      url: (link?.url || '').trim(),
    }))
    .filter((link) => link.url);
}
